import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import * as Yup from 'yup';
import Helmet from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';
import { Field, useSession, Form } from '@cordata/buffet';

import { Splash } from '~/components';

const TwoFactorAuthorization = () => {
  const history = useHistory();
  const { loginTfa } = useSession();

  return (
    <Splash>
      <Helmet title="Two Factor Authorization" />

      <Form
        displayName="Two Factor Authorization Form"

        initialValues={{
          token: '',
          userName: localStorage.getItem('session'),
        }}

        onSubmit={(values, { setErrors, setSubmitting }) =>
          loginTfa({ 'auth-code': values.token, username: values.userName })
            .then((r) => {
              console.log(JSON.stringify(r));

              setTimeout(() => history.push('/home'), 350);
            })
            .catch((e) => {
              const isLocked = typeof e === 'object' && e.response && e.response.status === 403;

              setErrors({ server: '', isLocked });
              setSubmitting(false);
            })
          }

        validationSchema={Yup.object().shape({
          token: Yup.string()
            .length(6)
            .required(),
        })}
      >
        {({
          isSubmitting,
        }) => (
          <>
            <Field
              name="token"
              label={false}
              autoFocus
              required
            />

            <Row form>
              <Col xs="auto">
                <Button
                  disabled={isSubmitting}
                  outline
                  color="light"
                  block
                  tag={Link}
                  to="/login"
                >
                  Cancel
                </Button>
              </Col>

              <Col>
                <Button type="submit" disabled={isSubmitting} block>
                  {isSubmitting ? 'Logging in ...' : 'Log In'}
                </Button>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Splash>
  );
};

export default TwoFactorAuthorization;
